export default "/images/336b6444f03b68391203f2d6725504d6.avif";